import React from "react";
import LoginComponent from "../../landing/login-component";

export default function Signup() {
  return <LoginComponent mode="signup" />;
}
